import { render, staticRenderFns } from "./subject-wise-performance-report.vue?vue&type=template&id=9a8e46f8&scoped=true&"
import script from "./subject-wise-performance-report.vue?vue&type=script&lang=js&"
export * from "./subject-wise-performance-report.vue?vue&type=script&lang=js&"
import style0 from "./subject-wise-performance-report.vue?vue&type=style&index=0&id=9a8e46f8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a8e46f8",
  null
  
)

export default component.exports